import _ from 'lodash'
import Rails from '@rails/ujs'

export default class Payment {
  constructor(base_url) {

    this.base_url = base_url
  }

  call() {
    this.getData()
  }

  getData() {
    let url = this.base_url + '/show_data?data_type=details';
    Rails.ajax({
      type: "GET",
      url: url,
      success: this.successResponse.bind(this)
    })
  }

  successResponse(response) {
    this.data = response
    this.wrapperPayment.innerHTML = this.parseTemplate()
    $('[data-toggle="tooltip"]').tooltip()
  }

  parseTemplate () {
    _.templateSettings = {
      evaluate:    /\{\{(.+?)\}\}/g,
      interpolate: /\{\{=(.+?)\}\}/g,
      escape:      /\{\{-(.+?)\}\}/g
    };

    let compiled = _.template(this.templatePayment.innerHTML)

    return compiled(this.data)
  }

  get wrapperPayment() {
    return document.getElementById('wrapper-payment')
  }

  get templatePayment() {
    return document.getElementById('template-payment')
  }
}